var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "utility-actions" }, [
    _c(
      "li",
      { staticClass: "utility-actions__item" },
      [
        _c("modify-calendar-modal", {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var activate = ref.activate
                return _c("div", {}, [
                  _c("button", {
                    staticClass: "button utility-actions__button-calendar",
                    attrs: {
                      "aria-label": _vm.ModifyReservationPageCalendarIcon,
                    },
                    on: {
                      click: activate,
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return activate($event)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return activate($event)
                        },
                      ],
                    },
                  }),
                ])
              },
            },
          ]),
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("li", { staticClass: "utility-actions__item" }, [
      _c("button", {
        staticClass: "button utility-actions__button-print",
        attrs: { "aria-label": _vm.ModifyReservationPagePrintIcon },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.print($event)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }